var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-1',[_c('div',{staticClass:"box-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }